import type { Entry } from 'contentful';

import { TypeLeafSkeleton, TypeMobileMenuSkeleton, TypeNodeSkeleton } from '../models/cms';
import { MenuItem } from '../../../MobileMenuList/MobileMenuList.props';

import { validateResponse } from '.';

export type ChildEntry = Entry<TypeNodeSkeleton, 'WITHOUT_UNRESOLVABLE_LINKS'> | Entry<TypeLeafSkeleton, 'WITHOUT_UNRESOLVABLE_LINKS'>;

export const transformMobileMenu = (entry: Entry<TypeMobileMenuSkeleton, 'WITHOUT_UNRESOLVABLE_LINKS'> | ChildEntry): MenuItem[] => {
  const menu =
    ('children' in entry.fields &&
      entry.fields.children
        ?.filter((x) => !!x)
        .map((child) => {
          validateResponse(child, ['label']);
          const base = { label: child.fields.label, startingIcon: child.fields.startingIcon };

          if ('children' in child.fields) {
            return { ...base, children: transformMobileMenu(child as ChildEntry) };
          } else if ('url' in child.fields) {
            return { ...base, url: child.fields.url as string };
          }
        })) ||
    [];

  return menu?.filter((x) => !!x);
};
